import React from 'react';
import { API_URL } from '../../constants/api';

const ProductCard = ({ product, onAdd,cart }) => {
  const isInCart = cart.some(item => item.ID === product.ID);

  return(
  <div
    className="card text-center p-2"
    style={{ width: '200px', cursor: 'pointer' }}
    onDoubleClick={() => onAdd(product)}
  >
    <img
       src={
  product.Image
    ? `${API_URL}/${product.Image}`
    : `${API_URL}/${product.Image2}`
}
      alt={product.Name}
      style={{ height: 150, objectFit: 'cover' }}
      className="card-img-top mb-1"
    />
    
    <div style={{ fontWeight: 'bold' }}>{product.Name}</div>
    <div className="text-muted">${product.Price}</div>
     {isInCart && (
        <span
          className="position-absolute top-0 end-0 bg-success text-white rounded-circle"
          style={{ width: 20, height: 20, fontSize: 14 }}
        >
          ✅
        </span>
      )}
  </div>
)
};

export default ProductCard;
